import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function NavBar() {
  const { logout } = useAuth();
  return (
    <AppBar position="static">
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <img 
            src="/logo192.png" 
            alt="ThinkGPT Logo" 
            style={{ height: '32px', marginRight: '10px' }} 
          />
          <Typography variant="h6" component="div">
            ThinkGPT AI Bookmarker
          </Typography>
        </Box>
        <Button color="inherit" component={RouterLink} to="/">
          Home
        </Button>
        <Button color="inherit" component={RouterLink} to="/account">
          Account
        </Button>
        <Button color="inherit" component={RouterLink} to="/bookmarks">
          Bookmarks
        </Button>
        <Button color="inherit" component={RouterLink} to="/presentations">
          Presentations
        </Button>
        <Button color="inherit" onClick={logout}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
}
